/* eslint-disable no-console,no-undef, camelcase */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import dayjs from 'dayjs';
//import LazyImage from '../common/LazyImage/LazyImage';
//import { ImageUrl } from '../../utils/constants';

const TimerContainer = styled.div`
  display: flex;
  height: 48px;
  width: ${({width}) => width ?  width: '255px'};
  margin: ${({margin}) => margin ?  margin: '0'};
  padding: 12px 20px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  border-radius: 4px;
  color: ${(props) => (props.isTextColor ? props.isTextColor : '#184A61')};
  text-align: center;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400; 
  line-height: 20px;
  ${'' /* background: #FCF2F3; */}
  background: ${(props) => (props.isBackgroundColor ? props.isBackgroundColor : '#FCF2F3')};
  text-transform:math-auto;
  
  ${'' /* .box{
  animation: animName 2s linear infinite;
}

@keyframes animName {
 0%{
    transform: rotate(0deg);
   }
100%{
    transform: rotate(360deg);
   }
} */}
  ${'' /* background: rgba(0, 92, 135, 0.10); */}
`;

const Timer = ({ data,startText, endTetxt,isBackgroundColor,isTextColor,width,margin }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00',
    isExpired: false,
  });

  useEffect(() => {
    let interval;
  
    const updateCountdown = () => {
      const targetDate = dayjs(data);
      const now = dayjs();
  
      const diffMs = targetDate.diff(now);
  
      if (diffMs <= 0) {
        setTimeLeft({ isExpired: true });
        clearInterval(interval);
        return;
      }
  
      const diffSeconds = Math.floor(diffMs / 1000);
      const diffMinutes = Math.floor(diffSeconds / 60);
      const diffHours = Math.floor(diffMinutes / 60);
      const diffDays = Math.floor(diffHours / 24);
  
      setTimeLeft({
        days: String(diffDays).padStart(2, '0'),
        hours: String(diffHours % 24).padStart(2, '0'),
        minutes: String(diffMinutes % 60).padStart(2, '0'),
        seconds: String(diffSeconds % 60).padStart(2, '0'),
        isExpired: false,
      });
    };
  
    interval = setInterval(updateCountdown, 1000);
    updateCountdown();
  
    return () => clearInterval(interval);
  }, [data]);
  

  const { days, hours, minutes, seconds, isExpired } = timeLeft;

  if (isExpired) {
    return (
      <TimerContainer {...{ isBackgroundColor, isTextColor, width, margin }}>
        <span>00</span>
      </TimerContainer>
    );
  }

  const showOnlyDays = Number(days) >= 1;

  

  return (
   
    <TimerContainer {...{ isBackgroundColor, isTextColor, width, margin }}>
      <span>{startText || 'Starts in :'}</span>
  
      {showOnlyDays ? (
        <span>{days}{days > 1 ? ' days' : ' day'}</span>
      ) : (
        <>
          <span>{hours}h</span>
          <span>{minutes}m</span>
          <span>{seconds}s</span>
        </>
      )}
  
      {endTetxt && <span>{endTetxt}</span>}
    </TimerContainer>

  );
};

Timer.propTypes = {
  data: PropTypes.object.isRequired,
  startText:PropTypes.string,
  endTetxt:PropTypes.string,
  isBackgroundColor:PropTypes.string,
  isTextColor:PropTypes.string,
  width:PropTypes.string,
  margin:PropTypes.string
};

export default connect(null, null)(Timer);
